import Vue from "vue"
import Vuex from "vuex"
import { plugins } from "@/plugins"

Vue.use(Vuex);
plugins.forEach(plugin => Vue.use(...plugin));

// primary: #584864  rgb(88, 72, 100)

/* if(process.env.NODE_ENV === "development"){
    const formatError = err => {
        if(err.name && err.message)
            return `${err.name} : ${err.message}`;

		console.table(err);
        return err.toString();
    };

	const vueHandler = type => (err, vm, info) => {
		Vue.$toast[type](formatError(err));
	};

    Vue.config.errorHandler = vueHandler("error");

    Vue.config.warnHandler = vueHandler("warning");
} */

export {
	Vue,
	Vuex
}